import React, { Suspense, useState } from 'react';
import { ReactLoadableComponent } from 'react-module-container';
import { createStandaloneComponentFlowAPI } from './flow-api/createStandaloneComponentFlowAPI';
export function createLazyComponent(requireableBMComponent, { flowAPIDelegate }) {
    const { component, asyncMessagesLoader, loadReactComponent, filesHook, resolveHook, } = requireableBMComponent;
    return (props) => {
        const [error, setError] = useState();
        const [fedopsLoggerOrGet] = useState(() => flowAPIDelegate.createGetFedopsLogger(component.componentId));
        const [getComponentI18nInstance] = useState(() => flowAPIDelegate.createGetComponentI18nInstance(asyncMessagesLoader));
        const [componentHooksFlowAPI] = useState(() => flowAPIDelegate.getComponentHooksFlowAPI(component, {
            fedopsLoggerOrGet,
            getComponentI18nInstance,
        }));
        const [Component] = useState(() => {
            return ReactLoadableComponent(component.componentId, async () => {
                try {
                    flowAPIDelegate.prefetchTranslations(asyncMessagesLoader);
                    flowAPIDelegate.prefetchExperiments();
                    const resolveDataPromise = resolveHook === null || resolveHook === void 0 ? void 0 : resolveHook.call(flowAPIDelegate.bmModule, componentHooksFlowAPI);
                    const componentFlowAPIPromise = flowAPIDelegate.createBMComponentAPI(component, {
                        fedopsLoggerOrGet,
                        getComponentI18nInstance,
                    });
                    const reactComponentPromise = loadReactComponent();
                    const [resolvedData, reactComponent, componentFlowAPI,] = await Promise.all([
                        resolveDataPromise,
                        reactComponentPromise,
                        componentFlowAPIPromise,
                    ]);
                    const resolveComponentFlowAPI = (maybeSyncFlowAPIDeps) => maybeSyncFlowAPIDeps
                        ? createStandaloneComponentFlowAPI(requireableBMComponent, {
                            flowAPIDelegate,
                            fedopsLoggerOrGet,
                        })(maybeSyncFlowAPIDeps)
                        : componentFlowAPI;
                    return Object.assign({ default: reactComponent(resolveComponentFlowAPI) }, resolvedData);
                }
                catch (e) {
                    setError(e);
                    throw e;
                }
            }, filesHook === null || filesHook === void 0 ? void 0 : filesHook.call(flowAPIDelegate.bmModule, componentHooksFlowAPI));
        });
        if (error) {
            throw error;
        }
        return (React.createElement(Suspense, { fallback: null },
            React.createElement(Component, Object.assign({}, props))));
    };
}
//# sourceMappingURL=createLazyComponent.js.map